<template>
  <UModal
    :value="settingRolesDialog"
    class="detail-roles"
    :class="$vuetify.theme.dark ? 'theme--dark' : 'theme--light'"
    @input="!loading && !savingRole && $emit('closeSettingsRoles')"
  >
    <template #default>
      <div
        class="roles-content"
      >
        <div class="header">
          {{ $t('members.settingRoles') }}
        </div>
        <div
          v-if="loading"
          class="roles-content"
        >
          <div class="header">
            {{ $t('members.loadingRoles') }}
          </div>
          <v-progress-linear :indeterminate="true" />
        </div>
        <template v-if="!createOrEdit && !loading">
          <ul class="roles-list">
            <li
              v-for="item in optionsRolesMembers"
              :key="item.uuid"
            >
              <div
                class="roles-list__name"
                @click="editRole(item)"
              >
                <p>{{ item.name }}</p>
                <small v-if="item.users.length > 0">
                  <span v-if="item.users.length === 1">
                    {{ item.users[0].user.name }}
                  </span>
                  <span v-else>
                    {{ item.users[0].user.name }}, 
                    {{ item.users[1].user.name }} 
                    {{ item.users.length > 2 ? `${$t('members.notAssigned')} ${item.users.length - 2}` : '' }}
                  </span>
                </small>
                <small v-else>{{ $t('members.notAssigned') }}</small>
              </div>
              <v-tooltip v-if="item.type !== 'default' && item.usersLength !== 0" top>
                <template v-slot:activator="{ on }">
                  <button
                    v-if="item.type !== 'default'"
                    :disabled="item.usersLength !== 0"
                    class="btn-delete"
                    v-on="on"
                    @click.stop="confirmDeleteMember(item)"
                  >
                    <IconCustom
                      :color="$vuetify.theme.dark ? '#FFFFFF' : '#96A2AE'"
                      name="icn20_trash_can"
                    />
                  </button>
                </template>
                {{ $t('members.deleteBtnTooltip') }}
              </v-tooltip>
              <button
                v-if="item.type !== 'default' && item.usersLength === 0"
                class="btn-delete"
                @click.stop="confirmDeleteMember(item)"
              >
                <IconCustom
                  :color="$vuetify.theme.dark ? '#FFFFFF' : '#96A2AE'"
                  name="icn20_trash_can"
                />
              </button>
            </li>
          </ul>
          <button
            class="create-role"
            @click="createOrEdit = true"
          >
            {{ $t('members.createRoleBtn') }}
          </button>
          <helper-confirm-dialog
            v-if="confirmDialog"
            :show-dialog="confirmDialog"
            :text="$t('members.roleReallyDelete', {name: selectedRole.name})"
            @closeConfirmDialog="closeConfirmDialog"
          />
        </template>
        <CreateOrEditRole
          v-if="createOrEdit && !loading"
          ref="createOrEditRole"
          :role="selectedRole"
          @editRoleBack="editRoleBack"
          @setSavingRole="setSavingRole"
          @reloadRoles="$emit('reloadRoles')"
        />
      </div>
    </template>
    <template #fixedContent>
      <button
        v-if="!loading && !createOrEdit"
        class="close-btn"
        block
        @click="$emit('closeSettingsRoles')"
      >
        {{ $t('globals.closeButton') }}
      </button>
      <div
        v-if="!loading && createOrEdit"
        class="action-role"
      >
        <button
          class="close-btn"
          block
          :disabled="savingRole"
          @click="editRoleBack"
        >
          {{ $t('members.backBtn') }}
        </button>
        <button
          class="save-btn"
          block
          :disabled="savingRole"
          :loading="savingRole"
          @click="saveRole"
        >
          {{ $t('globals.saveButton') }}
        </button>
      </div>
    </template>
  </UModal>
</template>

<script>


import { mapGetters } from 'vuex'
import UModal from "@/components/helper/UModal.vue";
import IconCustom from "@/components/helper/IconCustom.vue";
import CreateOrEditRole from "@/views/Members/partial/CreateOrEditRole.vue";
import DELETE_ROLE_MUTATION from "@/graphql/mutations/DeleteRole.gql";

export default {
  name: "SettingsRoleDialog",
  components: {
    UModal,
    IconCustom,
    CreateOrEditRole
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    roles: {
      type: Array,
      default: null
    },
    teamMembers: {
      type: Array,
      default: null
    },
    uploadLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      savingRole: false,
      providerUuid: this.$ls.get('config').uuid,
      confirmDialog: false,
      selectedRole: null,
      createOrEdit: false,
    }
  },
  computed: {
    ...mapGetters("whitelabel", ["getWhiteLabel"]),
    settingRolesDialog: {
      get() {
        return this.showDialog;
      },
      set(val) {
        this.$emit("closeSettingsRoles", val);
      }
    },
    optionsRolesMembers() {
      return this.roles && this.teamMembers
        ? this.roles.map(role => {
          const findMembers = this.teamMembers.filter(user => user.role.name === role.name && user.status !== "canceled");
          return {
            ...role,
            users: findMembers.filter(user => user.status !== "invited"),
            usersLength: findMembers.length
          }
        }) : []
    }
  },
  watch: {
    uploadLoading(val){
      this.loading = val;
    }
  },
  methods: {
    confirmDeleteMember(item) {
      this.confirmDialog = true
      this.selectedRole = item
    },
    closeConfirmDialog(confirmed) {
      this.confirmDialog = false
      if (confirmed) {
        this.deleteRole(this.selectedRole.uuid)
      }
      this.selectedRole = null
    },
    editRole(item) {
      this.selectedRole = item;
      this.createOrEdit = true;
    },
    editRoleBack(val) {
      this.selectedRole = null;
      this.createOrEdit = false;
    },
    setSavingRole(val) {
      this.savingRole = val;
    },
    saveRole() {
      this.$refs.createOrEditRole.save();
    },
    deleteRole(uuidRole) {
      this.loading = true;
      let params = {
        whitelabel_uuid: this.getWhiteLabel.uuid,
        role_uuid: uuidRole,
      }
      this.$apollo
        .mutate({
          mutation: DELETE_ROLE_MUTATION,
          variables: params
        })
        .then(data => {
          this.$store.commit('app/setNotifier', this.$t('globals.success'));
          this.$emit("reloadRoles");
        })
        .catch(error => {
          this.errorHandler(error);
          this.loading = false;
        });
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/material-dashboard/_colors.scss";
@import "@/styles/material-dashboard/_variables.scss";

.detail-roles {
  .roles-content {
    flex-direction: column;
    display: flex;
    gap: 24px;
    .header {
      font-size: 20px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      /* margin-bottom: 24px; */
    }
    .roles-list {
      padding: 0;
      li {
        list-style-type: none;
        padding: 12px 0;
        display: flex;
        &:hover {
          cursor: pointer;
          border-radius: 4px;
        }
        .roles-list__name {
          flex: 1 1 100%;
          p {
            margin: 0;
            font-size: 13px;
            font-weight: 600;
            line-height: normal;
          }
          small {
            font-size: 11px;
            font-weight: 500;
            line-height: normal;
          }
        }
        .btn-delete {
          width: 40px;
        }
      }
    }
    .create-role {
      border-radius: 8px;
      background: var(--primary-color, #0059FF);
      padding: 12px 16px;
      justify-content: center;
      align-items: center;
      gap: 8px;
      align-self: stretch;
      color: #ffffff;
      font-size: 13px;
      font-weight: 600;
      line-height: 20px;
    }
  }

  .close-btn {
    width: 100%;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 1 0 0;
    padding: 18px 32px;
    font-size: 15px;
    font-weight: 600;
    line-height: 20px;
  }

  .action-role {
    display: flex;
    gap: 8px;
    .save-btn {
      border-radius: 8px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      flex: 1 0 0;
      padding: 18px 32px;
      font-size: 15px;
      font-weight: 600;
      line-height: 20px;
      background: var(--primary-color, #0059FF);
      color: #ffffff;
    }
  }

  &.theme--dark {
    .roles-content {
      .roles-list {
        li {
          &:hover {
            background: #091a31!important;
          }
        }
      }
    }
  }
  &.theme--light{
    .roles-content {
      .roles-list {
        li {
          &:hover {
            background: #fcfcfc!important;
          }
        }
      }
    }
    .close-btn {
      background: var(--light-theme-surface-color-10, rgba(49, 57, 44, 0.10));
    }
  }

  .roles-content,
  .form-role {
    overflow-y: auto;
    max-height: calc(100vh - 158px);
    &::-webkit-scrollbar {
      -webkit-appearance: none;
      width: 7px;
    }

    &::-webkit-scrollbar-track {
      background-color: #F1F1F1 ;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #C1C1C1;
      border-radius: 4px;
    }
    &::-webkit-scrollbar-button,
    &::-webkit-scrollbar-track-piece {
      display: none;
    }
  }

}
</style>
